<template>
  <component
    :is="link ? 'router-link' : 'div'"
    :to="link || undefined"
    :style="link ? 'cursor:pointer;height:4vw;' : 'cursor:default;height:4vw;opacity:0.6;'"
    class="d-flex flex-column align-items-center justify-content-center card bg-white mx-2 shadow p-1 rounded mb-1"
  >
    <img style="width: 3vw;" src="/img/karbarg.png" alt="">
    <h5 style="font-size: 0.8vw !important">{{ title }}</h5>
  </component>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
  },
}
</script>
